import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ["popover", "pending", "confirmed"];
  static values = { url: String };

  connect() {
    this._boundCloseOnOutsideClick = this._closeOnOutsideClick.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this._boundCloseOnOutsideClick);
  }

  toggle(event) {
    event.stopPropagation();

    this.popoverTarget.classList.toggle("hidden");

    if (!this.popoverTarget.classList.contains("hidden")) {
      document.addEventListener("click", this._boundCloseOnOutsideClick);
    } else {
      document.removeEventListener("click", this._boundCloseOnOutsideClick);
    }
  }

  confirm(event) {
    event.preventDefault();

    Rails.ajax({
      url: this.urlValue,
      type: 'POST',
      success: () => {
        this.pendingTarget.classList.add("hidden");
        this.confirmedTarget.classList.remove("hidden");

        this._hidePopover();
      }
    });
  }

  _closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this._hidePopover();
    }
  }

  _hidePopover() {
    this.popoverTarget.classList.add("hidden");
    document.removeEventListener("click", this._boundCloseOnOutsideClick);
  }
}
